/**
 * Sets a custom flag on the global Cypress flags object.
 * Can be used to signal to Cypress tests that certain conditions have been met.
 *
 * @example setCypressFlag('cartReady', true);
 */
export function setCypressFlag(key, value) {
  window.__CYPRESS_FLAGS__ ??= {};
  window.__CYPRESS_FLAGS__[key] = value;
}
